import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { DateFromTo } from '../../models/common';
import { getDateForApi } from '../../utils/date';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { invitationService } from '@api/services/services';
import { WorkerStatus } from '@api/models/enums/WorkerStatus';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { InvitationType } from '@api/models/enums/InvitationType';
import { InvitationDto } from '@api/models/invitation/InvitationDto';
import { InvitationState } from '@api/models/enums/InvitationState';

export interface InvitationListFilter extends ListFilter {
  name?: string;
  supplier?: ReferenceDto;
  supplierEmployee?: SupplierEmployeeDto;
  employee?: ReferenceDto;
  validFrom?: DateFromTo;
  validTo?: DateFromTo;
  validToEmpty?: boolean;
  state?: InvitationState[];
  invitationTypes?: InvitationType[];
  workerStatus?: WorkerStatus[];
}

export type InvitationListState = ListType<InvitationDto, InvitationListFilter>;

const initialState: InvitationListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'validFrom',
    sortDesc: true,
    //Changed in identity after login. `identity.ts:136`
    state: Object.values(InvitationState).filter((x) => x !== InvitationState.Archived),
  },
};

export const invitationListSlice = listSlice({
  name: 'invitationList',
  initialState,
});

export const selectInvitationList = (state: RootState) => state.invitationList;
export const invitationListActions = invitationListSlice.actions;

export const getInvitationList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectInvitationList(storeState);

  const handleGetData = (size: number) => {
    return invitationService.query(
      {
        q: data.query.q || undefined,
        supplier: data.query.supplier?.id,
        personOnInvitation: data.query.supplierEmployee?.id,
        employee: data.query.employee ? [data.query.employee.id] : undefined,
        invitationStartFrom: getDateForApi(data.query.validFrom?.from),
        invitationStartTo: getDateForApi(data.query.validFrom?.to),
        invitationEndFrom: getDateForApi(data.query.validTo?.from),
        invitationEndTo: getDateForApi(data.query.validTo?.to),
        validToEmpty: data.query.validToEmpty || undefined,
        state: data.query.state,
        invitationTypes: data.query.invitationTypes,
        workerStatus: data.query.workerStatus,
        page: data.query.page,
        size: size,
        sort: [...(getListSort(data) || []), 'created,desc'],
      },
      { cancelToken: cancelToken },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: invitationListActions,
    getData: handleGetData,
  });
};
